import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
// import QrcodeScan from "../../../Assets/img/icons/QRcode Scanner.svg";
// import NeoinScan from "../../../Assets/img/icons/Neoin-at-center.svg";
// import { ReactComponent as CardWaveWithoutShadow } from "../../../Assets/img/card/waveline new.svg";
// import NeoinQR from "../../../Assets/img/icons/QR-with-Neoin.svg";
// import DefaultProfile from "../../../Assets/img/Default-Profile.png";
// import CompanyLogo from "../../../Assets/img/Neoin-logo.png";
// import QrCode2Icon from "@mui/icons-material/QrCode2";
// import ShareIcon from "@mui/icons-material/Share";
// import MapIntegration from "../Mapintegration";
import { ReactComponent as MessageIcon } from "../../../Assets/img/icons/message-icon.svg";
// import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { ReactComponent as SharingIcon } from "../../../Assets/img/icons/shareicon.svg";
import { ReactComponent as CopyIcon } from "../../../Assets/img/icons/Copyicon.svg";
import { ReactComponent as DownloadIcon } from "../../../Assets/img/icons/apple Wallet Download.svg";
import TextField from "@mui/material/TextField";
import { ReactComponent as ContactListIcon } from "../../../Assets/img/icons/contact list.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../Assets/img/icons/tick-shape.svg";
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import { Autocomplete, Button, InputAdornment, Snackbar } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { MuiTelInput } from "mui-tel-input";
import applewalletbottom from "../../../Assets/img/applewallet-bottom.png";
import dribbleapp from "../../../Assets/img/icons/dribbble 1.svg";
import Whatsapp from "../../../Assets/img/icons/whatsapp.svg";
import linkin from "../../../Assets/img/icons/linkedin.svg";
import gitthub from "../../../Assets/img/icons/github.svg";
import msginput from "../../../Assets/img/icons/messageinput.svg";
import mastercard from "../../../Assets/img/mastercard.svg";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as Download } from "../../../Assets/img/icons/Download-share.svg"
import facebook from '../../../Assets/img/icons/Facebook.svg'
import whatsapp from '../../../Assets/img/icons/whatsapp.svg'
import insta from '../../../Assets/img/icons/instagram.svg'
import linkedin from '../../../Assets/img/icons/linkedin.svg'
import signal from '../../../Assets/img/icons/signal.svg'
import telegram from '../../../Assets/img/icons/Telegram.svg'
import loaderGif from '../../../Assets/img/icons/Animation - 1718370478484.gif'
import { saveAs } from 'file-saver';
import { useUserDetailContext } from '../../UserDetailContext';
import { useCardDetailContext } from '../../CardDetailContext';
import QrCodeCard from "./QrCodeCard";
import DefaultProfileBg from "../../../Assets/img/card/profilebg.png";
import DefaultLogo from "../../../Assets/img/default-logo.png";
import { getIconAndLabel } from '../../Utilities/SocialMediaMapping'
import { useParams } from 'react-router-dom';
import CardWaveStd from "../../Utilities/CardWaveStd";
import CardWaveSmile from "../../Utilities/CardWaveSmile2";
import PreviewCard from "./PreviewCard";
import useAvailableHeight from "../../Custom/UseAvailableHeight";
import { useQuantityContext } from "../../QuantityContext";
import { motion } from 'framer-motion';
import PreviewCardSkeleton from "../../LoadingSkeleton/PreviewCardSkeleton";
import ShareQR from "./ShareQR";


function CardDetailedView() {

  const { cards, AllCards, cardDetailsAll, cardStylesAll, userDetails, allCardDetails } = useUserDetailContext();
  const { cardDetails, setCardDetails, cardAcademyDetails, setCardProfDetails, CardStyles,
    setCardStyles, updateCardQrStyles, updateContactStyles, updateCardStyles, setCardQrStyles,
    setSocialLinks, setContactStyles, setAttachDocs, updateAttachDocsVal, setSocialLinkShow } = useCardDetailContext();
  const { openSnackbar } = useQuantityContext();
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');

  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${objectId}`,
    // "ngrok-skip-browser-warning": "69420"
  };
  const { id } = useParams();
  // const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [nameSms, setNameSms] = useState("");
  const [emailInput, setEmailInput] = useState('');
  const [emailMessage, setEmailMessage] = useState("");
  const [nameError, setNameError] = useState(false);
  const [nameError2, setNameError2] = useState(false);

  const [emailError, setEmailError] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState({
    email: false,
    phone: false
  })
  const updateButtonDisabled = (updatedState) => {
    setIsButtonDisabled((prevState) => ({
      ...prevState,
      ...updatedState
    }))
  }
  const [anchorEl, setAnchorEl] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("+91");
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({ title: '', body: '' });
  // const [cards, setCards] = useState(['Professional', 'Personal']);

  // Check if objectId is not null and not an empty string after trimming
  if (objectId !== null && objectId.trim() !== "") {
    // console.log("objectId is present:", objectId);
  } else {
    // If objectId is not present or is an empty string after trimming
    // console.log("objectId is not present or is empty.");
  }
  const [url, setUrl] = useState(`${process.env.REACT_APP_CARD_URL}/digital-identity/${id}/${objectId}`);
  const handleSuccess = () => {
    openSnackbar("Sent Successfully!", "success");
  };

  const handleSuccessCopy = () => {
    openSnackbar("Copied Successfully!", "success");
  };

  const handleFailure = () => {
    openSnackbar("Failed to Send", "error");
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };
  // Function to convert canvas to PNG or JPEG
  const canvasToImage = (canvas, type) => {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, type);
    });
  };

  // Function to handle download button click
  const handleDownload = async () => {
    const canvas = document.querySelector('canvas');
    const blob = await canvasToImage(canvas, 'image/png'); // Change to 'image/jpeg' for JPEG format
    saveAs(blob, name); // Change file name and extension accordingly
  };

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  const handleCopyLink = async () => {
    try {
      console.log("Copy Link clicked!");
      const qrCodeLink = `${process.env.REACT_APP_CARD_URL}/digital-identity/${id}/${objectId}`;

      await navigator.clipboard.writeText(qrCodeLink);
      handleSuccessCopy();
    }

    catch (error) {
      console.error("Error copying link:", error);
      // toast.error("Unable to copy Link. Try later.", {
      //   className: "copy-link-fail"
      // });
      setSnackbarMessage({
        title: 'Failed',
        body: 'Failed to approve the request.'
      });
      setSnackbarOpen(true);
    }
  }


  const handleClickOpen = () => {
    setPopoverOpen(true);
  };

  const handleClose = () => {
    setPopoverOpen(false);
  };

  const [phoneError, setPhoneError] = useState(false);
  const handlePhoneChange = (newValue) => {
    setPhoneNumber(newValue);

    // Validate the phone number using the new value directly
    if (newValue.length < 10) {
      setPhoneError(true);
    } else {
      setPhoneError(false);
    }
  };


  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);


  const handleSuccessSMS = () => {
    openSnackbar("Sent Successfully!", "success")
  };

  const handleFailureSMS = () => {
    openSnackbar("Failed to Send", "error")
  };

  const handleChangeName = (event) => {
    setName(event.target.value);
    setNameError(false); // Reset error when user types
  };

  const handleChangeSms = (event) => {
    setNameSms(event.target.value);
    setNameError(false);
  };

  const handleSendEmail = async (event) => {
    event.preventDefault(); // Prevent default form submission

    if (!name.trim()) {
      setNameError(true);
    } else {
      setNameError(false);
    }

    if (!emailInput.trim() || !isValidEmail(emailInput)) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }

    if (name.trim() && isValidEmail(emailInput)) {
      try {
        updateButtonDisabled({ email: true });
        openSnackbar("Sending the E-mail...", "info", 3000);
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/mail/send-email-qrlink`, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ emails: [emailInput], url, message: emailMessage ? emailMessage + ` Here's a link to my ${id} card:` : `Here's a link to my ${id} card:`, name: name, cardType: `${id} Card`, objectId })
        });

        if (response.ok) {
          handleSuccess();
          setName('');
          setEmailInput('');
          setEmailMessage('');
        } else {
          throw new Error('Failed to send email');
        }
      } catch (error) {
        console.error('Error sending email:', error.message);
        handleFailure();
      } finally {
        updateButtonDisabled({ email: false })
      }
    }
  };

  const [phoneNumberError, setphoneNumberError] = useState(false);
  const handleSendButtonClick = async (event) => {
    event.preventDefault(); // Prevent default form submission

    if (phoneNumber.length < 10) {
      setPhoneError(true);
      return;
    }
    else {
      openSnackbar("Sending SMS...", "info", 3000);
      updateButtonDisabled({ phone: true })
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/mail/send-sms-qrlink`, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ phoneNumber, url, cardType: id })
        });
        if (response.ok) {
          handleSuccessSMS();
          setNameSms('');
          setPhoneNumber('+91');
          setEmailMessage('');

        } else {
          handleFailureSMS();
          throw new Error('Failed to send SMS');
        }
      } catch (error) {
        console.error('Error sending SMS:', error.message);
        handleFailure();
      } finally {
        updateButtonDisabled({ phone: false })
      }
    }
  };

  // const handleChangeEmail = (event) => {
  //   setEmailInput(event.target.value);
  //   setemailError(false); // Reset error when user types
  // };

  const handleBlurName = () => {
    if (!name.trim()) {
      setNameError(true); // Show error if name is empty
    } else {
      setNameError(false);
    }
  };

  const handleBlurName2 = () => {
    if (!nameSms.trim()) {
      setNameError2(true);
    }
    else {
      setNameError2(false);
    }
  }

  const handleBlurEmail = () => {
    if (!emailInput.trim()) {
      setEmailError(false); // Show error if email is empty
    } else {
      setEmailError(false);
    }
  };

  // const handleAddEmail = (event) => {
  //   if ((event.key === 'Enter' || event.key === ',' || event.key === ' ') && emailInput.trim()) {
  //     const email = emailInput.trim();
  //     if (/\S+@\S+\.\S+/.test(email) && !email.includes(' ')) { // Basic email validation
  //       setEmails([...emails, email]);
  //       setEmailInput('');
  //       setemailError(false);
  //     } else {
  //       setemailError(true);
  //     }
  //     event.preventDefault();
  //   }
  // };

  // const handleDeleteEmail = (emailToDelete) => () => {
  //   setEmails(emails.filter(email => email !== emailToDelete));
  // };

  const [activeLink, setActiveLink] = useState("content1");
  const handleLinkClick = (content) => {
    setActiveLink(content);
  };
  // useEffect(() => {
  //   const lat = parseFloat(ContactStyles.latitude);
  //   const lon = parseFloat(ContactStyles.longtitude);

  //   if (!isNaN(lat) && !isNaN(lon)) {
  //     setLatitude(lat);
  //     setLongitude(lon);
  //   } else {
  //     setLatitude('');
  //     setLongitude('');
  //   }
  // }, [ContactStyles.latitude, ContactStyles.longtitude]);

  const Designation = cardDetails?.Designation || ''
  // console.log("cradDetails use company logo",Logo);
  // const [emails, setEmails] = useState('');
  const [ProfilePicture, setProfilePicture] = useState('');
  const [companyLogo, setcompanyLogo] = useState('');

  const [emails, setEmails] = useState([]);
  // const [emailInput, setEmailInput] = useState('');
  // const [emailError, setEmailError] = useState(false);

  const isValidEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  useEffect(() => {
    if (cardDetails?.profile_pic && cardDetails?.profile_pic !== '') {
      setProfilePicture(cardDetails.profile_pic);
    }
    else {
      setProfilePicture(DefaultProfileBg);
    }

    if (cardDetails?.logo && cardDetails?.logo !== '') {
      setcompanyLogo(cardDetails.logo);
    }
    else {
      setcompanyLogo(DefaultLogo);
    }
  }, [cardDetails]);

  const initialCardDetails = {
    User_ID: objectId,
    CardType: `${id}`,
    CardName: `${id}`,
    prefix: '',
    suffix: '',
    title: '',
    nickname: '',
    summary: '',
    designation: '',
    company: '',
    profile_pic: '',
    logo: ''
  };

  const initialCardStyles = {
    User_ID: objectId,
    CardType: `${id}`,
    CardName: `${id}`,
    font: '',
    size: '',
    style: '',
    colorPrimary: '',
    colorSecondary: '',
    colorTitle: '',
    colorLayout: '#0044c6',
    bgColor: '#ffffff',
    layoutStyle: id === 'Personal' ? '2' : '1',
  };

  const initialCardQrStyles = {
    User_ID: objectId,
    CardType: `${id}`,
    CardName: `${id}`,
    eyeBall: '',
    eyeBallcolor: '',
    eyeFrame: '',
    eyeFrameColor: '',
    qrPattern: '',
    qrPatterncolor: '#121212',
    border: '',
    bordercolor: '',
    addbg: '',
    addbgcolor: '#ede8e8'
  };

  const initialCardSocialLinks = {
    User_ID: objectId,
    card_type: `${id}`,
    CardName: `${id}`,
    links: [
      { network: 'linkedin', url: '', visible: false },
      // { network: 'whatsapp', url: 'https://wa.me/', visible: false },
      { network: 'facebook', url: '', visible: false },
      { network: 'instagram', url: '', visible: false },
    ],
  }

  const initialContactStyles = {
    card_type: ``,
    CardName: `${id}`,
    location: '',
    mobile_number: `${userDetails.phone}`,
    call_visible: true,
    sms_visible: true,
    email: id == "Professional" ? "" : userDetails.email,
    email_visible: true,
    whatsapp: '',
    whatsapp_visible: true,
    address: '',
    state: '',
    postal_code: '',
    city: '',
    country: '',
    is_public: true,
  }

  const initialAttachDocs = {
    user_ref_id: "",
    card_id: null,
    card_name: "",
    images: [],
    videos: [],
    others: []
  }

  useEffect(() => {
    let CorrectCardType;
    const fetchCardDetails = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/getParticularCardInfo`, {
          params: {
            CardName: id,
            referenceId: objectId
          },
          headers: headers
        });

        // console.log('Fetched card details:', response.data);
        if (response.data.Details.length > 0) {
          const details = response.data.Details[0];

          // Create a new object with renamed keys and omit the old key
          const { user_ref_id, ...restDetails } = details; // Destructure to remove user_ref_id
          const renamedDetails = {
            ...restDetails,
            User_ID: user_ref_id, // Add User_ID with the value of user_ref_id
          };
          setCardDetails(renamedDetails);
          CorrectCardType = renamedDetails.CardType;
          // updateCardStyles({ "CardType": renamedDetails?.CardType });
          // updateCardQrStyles({ "CardType": renamedDetails?.CardType });
          // updateSocialLinks2({ "card_type": renamedDetails?.CardType });
          // updateContactStyles({ "card_type": renamedDetails?.CardType });  
        }
        else {
          setCardDetails(initialCardDetails);
        }
        if (response.data.QrStyles.length > 0) {
          setCardQrStyles(response.data.QrStyles[0]);
        }
        else {
          setCardQrStyles(initialCardQrStyles);
        }
        if (response.data.CardDesigns.length > 0) {
          setCardStyles(response.data.CardDesigns[0]);
        }
        else {
          setCardStyles(initialCardStyles);
          if (CorrectCardType === "Customize_Personal" || CorrectCardType === "Personal") {
            updateCardStyles({ "layoutStyle": '2' });
          }
        }
      } catch (error) {
        console.error('Error fetching card details:', error);
      }
      finally {
        setLoading(false);
        if (CorrectCardType) {
          updateCardStyles({ "CardType": CorrectCardType });
          updateCardQrStyles({ "CardType": CorrectCardType });
        }
      }

      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/get-social-links`, {
          params: {
            cardType: id,
          },
          headers: headers,
        });

        // Transform the response data
        const transformedLinks = response.data.map((link) => ({
          network: link.info_key,
          url: link.info_value,
          visible: link.is_visible,
        }));

        // Remove duplicates based on the network property
        const uniqueLinks = transformedLinks.filter((link, index, self) =>
          index === self.findIndex((t) => t.network === link.network)
        );

        // Set the state with unique links
        setSocialLinkShow({
          user_ref_id: objectId,
          card_type: id,
          links: uniqueLinks,
        });


        setSocialLinks({
          user_ref_id: objectId,
          card_type: id,
          links: uniqueLinks,
        });
      } catch (error) {
        // console.error('Error fetching Social Links:', error);
        setSocialLinks(initialCardSocialLinks);
      } finally {
        setLoading(false);
        // if (CorrectCardType) {
        //   updateSocialLinks2({ "card_type": CorrectCardType });
        // }
      }

      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/getcard-contacts`, {
          params: {
            card_type: id,
          },
          headers: headers,
        });
        if (response.status === 200) {
          setContactStyles(response.data[0]);
        }
        else {
          setContactStyles(initialContactStyles);
        }
      }
      catch (error) {
        console.log("It does not fetch the Card Contact Details");
        setContactStyles(initialContactStyles);
      }
      finally {
        if (CorrectCardType) {
          updateContactStyles({ "card_type": CorrectCardType });
        }
      }

      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/card_document/${id}`,
          { headers: headers }
        );
        const { data } = response.data;

        if (data.length < 1) {
          console.log("It is not Happening mean data is", data);
          setAttachDocs(initialAttachDocs);
          return;
        }

        const restructuredData = {
          user_ref_id: data.length ? data[0].user_ref_id : "",
          card_id: data.length ? data[0].card_id : null,
          card_name: id,
          images: [],
          videos: [],
          others: []
        };

        data.forEach((doc) => {
          const document = {
            name: doc.document_name,
            size: doc.size,
            date: doc.date,
            type: doc.document_type,
            data: doc.public_url,
            fileCat: doc.file_cat,
            fileId: doc.id,
            showQR: doc.showQR,
            visible: doc.is_visible,
          };

          if (doc.file_cat === 'images') {
            restructuredData.images.push(document);
          } else if (doc.file_cat === 'videos') {
            restructuredData.videos.push(document);
          } else {
            restructuredData.others.push(document);
          }
        });

        // Update the state with the restructured data
        setAttachDocs(restructuredData);

      } catch (error) {
        console.error('Error fetching documents:', error);
        // Handle error accordingly, like showing an alert or a message to the user
      }
      finally {
        updateAttachDocsVal({ fieldName: "card_name", value: id });
      }
    };

    fetchCardDetails();
  }, [cards, objectId]);

  const phoneNo = userDetails.phone.replace(/\s+/g, "");

  const message = url;
  const encodedMessage = encodeURIComponent(message);
  const encodedTitle = "hi";
  const whatsappLink = `https://api.whatsapp.com/send?text=${encodedMessage}`;
  // const telegramUsername = "YourTelegramUsername"; 
  const telegramLink = `https://t.me/${phoneNo}?text=${encodedMessage}`;
  const signalLink = `sgnl://send?phone=${phoneNo}&text=${encodedMessage}`;

  const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodedMessage}&quote=${encodedMessage}`;
  const linkedinLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedMessage}&title=${encodedTitle}&summary=${encodedMessage}`;

  const instagramLink = `https://www.instagram.com/${phoneNo}/`;

  const getDisplayTitle = (title) => {
    switch (title) {
      case "Social Media":
        return "My Social Network";
      case "Business":
        return "My Businesses";
      case "Contact":
        return "My Contacts"
      case "Payment":
        return "My Payment Links"
      case "More":
        return "Others"
      case "Music":
        return "My Music"
      case "Portfolio":
        return "My Portfolio"
      case "Content":
        return "My Content"
      default:
        return title;
    }
  };

  const getFontWeight = (style) => {
    switch (style) {
      case 'Light':
        return 300; // Font weight for Light
      case 'Regular':
        return 500; // Font weight for Regular
      case 'Medium':
        return 600; // Font weight for Medium
      case 'Semi Bold':
        return 700; // Font weight for Semi Bold
      case 'Bold':
        return 800; // Font weight for Bold
      default:
        return 'normal'; // Default font weight
    }
  };

  const PhoneInputMenuProps = {
    PaperProps: {
      style: {
        maxHeight: "calc(50% - 96px)",
        marginTop: "20px",
      }
    }
  }

  const [availableHeight1, Column1Ref] = useAvailableHeight(166);
  const [availableHeight2, Column2Ref] = useAvailableHeight(166);
  const [availableHeight3, Column3Ref] = useAvailableHeight(166);

  const bottomToTopVariants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -100 },
  };

  const rightToLeftVariants = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -100 },
  };

  if (loading) {
    return <PreviewCardSkeleton />
  }
  const [firstName, lastName] = userDetails.name.split(' ');
  const cardVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };
  // console.log("data in side the CARD DETAILS VIEW", AllCards);
  return (
    <div className="professional-card-view" >
      <div className="card-box my-4 ms-4 card-view-1" ref={Column1Ref} style={{ fontStyle: CardStyles ? CardStyles.style : "Lato", fontFamily: CardStyles ? CardStyles.font : "Lato", fontWeight: getFontWeight(CardStyles.style), fontSize: CardStyles ? CardStyles.size : '', color: CardStyles ? CardStyles.colorSecondary : '', backgroundColor: CardStyles.bgColor, maxHeight: `${availableHeight1}px`, overflowY: "auto", scrollbarWidth: "none", }}>
        <motion.div initial="hidden"
          animate="visible"
          exit="exit"
          variants={cardVariants}
          transition={{ duration: 0.5 }}>
          <PreviewCard isInsideModal={true} />
        </motion.div>
      </div>
      <div className="className"></div>
      <motion.div className="card-box-2 my-4 mx-4 expandable" ref={Column2Ref} style={{ maxHeight: `${availableHeight2}px`, minHeight: `${availableHeight1}px`, overflowY: "auto", scrollbarWidth: "none", }} initial="hidden" animate="visible"
        exit="exit"
        variants={bottomToTopVariants}
        transition={{ duration: 0.5 }}>
        <div>
          <div className="nav-tab-professionals pt-3">
            <TabContext value={activeLink}>
              <TabList
                onChange={(e, newValue) => setActiveLink(newValue)}
                aria-label="content tabs"
                className="d-flex custom-tablist"
              >
                <Tab label="QR Code" value="content1" className="tab-item" />
                <Tab label="Email" value="content2" className="tab-item" />
                <Tab label="SMS" value="content3" className="tab-item" />
                <Tab label="Wallet" value="content4" className="tab-item me-2" />
              </TabList>
            </TabContext>
          </div>
          <div className="tab-content">
            {/* {activeLink === "content1" && ( */}
            <div style={{ display: activeLink === "content1" ? 'block' : 'none' }}>
              <div className="qr-outline-container">
                <div className="qr-title mt-1">Scan Me</div>
                <div className="qr-center text-center">
                  {cardDetails?.is_experience_current === true && (cardDetails?.CardType === 'Professional' || cardDetails?.CardType === "Customize_Professional") ?
                    <a
                      href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${id}/${objectId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {/* <div>
                    <div ref={qrCodeRef}></div>
                  </div> */}
                      <QrCodeCard CARDNAME_id={id} />
                    </a> : ""}
                  {(cardDetails?.CardType === "Student" || cardDetails?.CardType === "Customize_Student" || cardDetails?.CardType === "Personal" || cardDetails?.CardType === "Customize_Personal") &&
                    <a
                      href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${id}/${objectId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {/* <div>
                    <div ref={qrCodeRef}></div>
                  </div> */}
                      <QrCodeCard CARDNAME_id={id} />
                    </a>}
                </div>
                <div className="professional-card-content mt-3 mb-3 mx-3 text-center">
                  scan or click to preview
                </div>
              </div>
              <div className="share-profile-container my-4">
                <div className="share-profile-box" style={{ borderRight: "1px solid #919eab1f" }}>
                  <SharingIcon
                    className="share-icon"
                    onClick={handleClickOpen}
                  />
                  <div className="share-text" onClick={handleClickOpen}>
                    Share
                  </div>
                </div>
                <div className="share-profile-box" onClick={handleCopyLink}>
                  <CopyIcon className="share-icon" />
                  <div className="share-text">Copy Link</div>
                  {/* <ToastContainer toastClassName="copy-link-success" />
                  <ToastContainer toastClassName="copy-link-fail" /> */}
                </div>
                {/* <BootstrapDialog
                  onClose={handleClose}
                  aria-labelledby="customized-dialog-title"
                  open={popoverOpen}
                  className="share-dialog"
                >
                  <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <DialogContent
                    dividers
                    sx={{ m: 0, p: 2, width: 500 }}
                  >
                    <Typography gutterBottom sx={{ m: 0, p: 0 }}>
                      <div className="text-center">
                        <a
                          href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${id}/${objectId}`}
                          rel="noopener noreferrer"
                        >
                          <QrCodeCard id={id} />
                        </a>
                      </div>
                    </Typography>
                    <Typography className="text-center downloadShareButtonNew" gutterBottom>
                      <button className="download-share-button mt-n1" onClick={handleDownload}>
                        <Download className="dowload-share-icon" />
                        Download QR Code
                      </button>
                    </Typography>
                    <Typography className="mt-4" gutterBottom>
                      <div className="share-qr-content">
                        Share with your friends
                      </div>
                      <div className="share-qr-subcontent text-left mt-2">
                        Connect and Share with Friends
                      </div>
                    </Typography>
                    <Typography gutterBottom>
                      <div className="row mt-3">
                        <div className="d-flex justify-content-between">
                          <a href={facebookLink} target='_blank' rel='noreferrer'>
                            <img src={facebook} alt="facebook" className="share-icons mr-3" />
                          </a>
                          <a href={whatsappLink} target='_blank' rel='noreferrer'>
                            <img src={whatsapp} alt='whatsapp' className="share-icons mr-3" />
                          </a>
                          <a href={instagramLink} target='_blank' rel='noreferrer'>
                            <img src={insta} alt="instagram" className="share-icons mr-3" />
                          </a>
                          <a href={linkedinLink} target='_blank' rel='noreferrer'>
                            <img src={linkedin} alt="linkedin" className="share-icons mr-3" />
                          </a>
                          <a href={signalLink} target='_blank' rel='noreferrer'>
                            <img src={signal} alt="signal" className="share-icons mr-3" />
                          </a>
                          <a href={telegramLink} target='_blank' rel='noreferrer'>
                            <img src={telegram} alt='telegram' className="share-icons" />
                          </a>
                        </div>
                      </div>

                    </Typography>
                  </DialogContent>
                </BootstrapDialog> */}
                <ShareQR cardType={id} sharePopover={popoverOpen} onClose={handleClose} />
              </div>
            </div>

            {activeLink === "content2" && (
              <div className="email-outline-container">
                <div className="email-title">Send your Card</div>
                <div className="email-content mt-2">
                  Email your personal card to:
                </div>

                <div className="my-3">
                  <TextField
                    required
                    error={nameError}
                    id="standard-required"
                    label="Name"
                    value={name}
                    onChange={handleChangeName}
                    onBlur={handleBlurName}
                    variant="standard"
                    className="custom-textfield mt-4"
                    placeholder="Recipient's Name"
                  />
                  {nameError && (
                    <div className="error-message ms-2">
                      Please enter your name
                    </div>
                  )}
                </div>

                <div className="my-3">
                  <TextField
                    required
                    error={emailError}
                    id="email-multiline"
                    label="E-mail ID"
                    value={emailInput}
                    onChange={(e) => { setEmailInput(e.target.value); setEmailError(false) }} // Update the entire content
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        const emailsArray = emailInput.split("\n"); // Split emails by new line
                        const lastEmail = emailsArray[emailsArray.length - 1].trim(); // Get the last email entered
                        if (isValidEmail(lastEmail)) {
                          setEmailError(false);
                        } else {
                          setEmailError(true); // Set error if the last email is invalid
                        }
                      }
                    }}
                    variant="standard"
                    className="custom-textfield"
                    // multiline
                    // minRows={3} // Minimum of 3 rows
                    // maxRows={5} // Allow for a maximum of 5 rows before scrolling
                    InputProps={{
                      style: { overflowY: 'auto' }, // Vertical scroll if more lines are added
                      endAdornment: (
                        <InputAdornment position="end">
                          <MessageIcon sx={{ marginRight: 2 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      width: "100%", // Adjust width as needed
                    }}
                  />
                  {emailError && (
                    <div className="error-message">Please enter valid emails</div>
                  )}
                </div>


                {/* Display the list of emails entered */}
                <div className="email-list">
                  {emails.map((email, index) => (
                    <div key={index} className="email-item">
                      {email}
                    </div>
                  ))}
                </div>


                {/* Display the list of emails entered */}
                <div className="email-list">
                  {emails.map((email, index) => (
                    <div key={index} className="email-item">
                      {email}
                    </div>
                  ))}
                </div>

                <div className="my-3">
                  <TextField
                    id="standard-basic"
                    label="Message"
                    variant="standard"
                    className="custom-textfield mt-3"
                    multiline
                    minRows={1}
                    autoComplete="off"
                    value={emailMessage}
                    onChange={(event) => { setEmailMessage(event.target.value) }}
                  />
                </div>

                <div className="popover-container">
                  <div className="switch-info-container">
                    <FormControlLabel
                      control={<Switch defaultChecked />}
                      label="Send via Neoin"
                      sx={{ marginRight: "0px" }}
                    />
                    <Typography
                      aria-owns={open ? "mouse-over-popover" : undefined}
                      aria-haspopup="true"
                      onMouseEnter={handlePopoverOpen}
                      onMouseLeave={handlePopoverClose}
                    >
                      <IconButton className="info-icon">
                        <InfoIcon />
                      </IconButton>
                    </Typography>

                    <Popover
                      id="mouse-over-popover"
                      sx={{
                        pointerEvents: "none",
                      }}
                      open={open}
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "bottom",
                      }}
                      onClose={handlePopoverClose}
                      disableRestoreFocus
                    >
                      <Typography
                        className="pop-content"
                        style={{ width: "500px" }}
                      >
                        <p className="pop-content">
                          If you'd like to maintain the privacy of your email, you
                          have the option to send your card using Neoin’s ID.
                        </p>
                      </Typography>
                    </Popover>
                  </div>
                </div>
                <div className="save-bottom my-3 pe-0" style={{ textAlign: "right", padding: "12px" }}>
                  <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={!isButtonDisabled.email ? handleSendEmail : undefined} disabled={nameError || emailError}>Send</Button>
                </div>
                {/* <ToastContainer toastClassName="email-toast-success" /> */}
              </div>
            )}

            {activeLink === "content3" && (
              <div className="sms-outline-container">
                <div className="email-title">Send your Card</div>
                <div className="email-content mt-2">
                  Text your Personal card to:
                </div>

                <div>
                  <TextField
                    required
                    error={nameError2}
                    id="standard-required"
                    label="Name"
                    value={nameSms}
                    // onChange={(event) => setNameSms(event.target.value)}
                    onChange={handleChangeSms}
                    onBlur={handleBlurName2}
                    variant="standard" // Change variant to standard
                    className="custom-textfield mt-4"
                  />
                  {/* {nameError && (
                    <div className="error-message ms-2">
                      Please enter your name12
                    </div>
                  )} */}
                </div>

                <div>
                  <MuiTelInput
                    name="phone"
                    id="standard-required"
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                    variant="standard"
                    required
                    MenuProps={PhoneInputMenuProps}
                    defaultCountry={"in"}
                    className={`custom-mui-tel-input mt-4 ph-no-input ${phoneError ? 'error' : ''}`}
                    sx={{ width: "100%" }}
                  />
                  {phoneError && (
                    <div className="error-message ms-2">
                      Phone number must be at least 10 digits long.
                    </div>
                  )}
                </div>


                <TextField
                  id="standard-basic"
                  label="Message"
                  variant="standard"
                  multiline
                  minRows={3}
                  autoComplete="off"
                  className="custom-textfield mt-3"
                  InputProps={{
                    // style: { padding: "30px 0px" }, // Adjust padding for more space between placeholder and input line
                  }}
                />
                <div className="save-bottom pe-0" style={{ textAlign: "right", padding: "12px" }}>
                  <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} disabled={nameError2 || phoneError} onClick={!isButtonDisabled.phone ? handleSendButtonClick : undefined}> Send </Button>
                </div>
                {/* <ToastContainer toastClassName="email-toast-success" /> */}
              </div>
            )}

            {activeLink === "content4" && (
              <>
                <div className="flex-center h-100" style={{ marginTop: "35px" }}>
                  {cardDetails.CardType === 'Student' ? (
                    <>
                      <div className="student-wallet-card">
                        <div className="student-wallet-header">
                          <span>STUDENT CARD</span>
                          <div className="college-logo">
                            <img src={companyLogo} alt='College Logo' />
                          </div>
                        </div>
                        <div className="student-wallet-body">
                          <div className="student-profile-picture">
                            <img src={ProfilePicture} alt='Profile Pic' />
                          </div>
                          <span>{userDetails.name}</span>
                          <span>{cardDetails?.title}</span>
                          <div className="student-info">
                            {[
                              { label: "ID", value: cardDetails?.student_id },
                              { label: "Course", value: cardDetails?.field_of_study },
                              {
                                label: "Duration", value: cardDetails?.student_year && cardDetails?.student_ending_year
                                  ? `${cardDetails.student_year} - ${cardDetails.student_ending_year}`
                                  : null
                              },
                            ].map((obj) => (
                              obj.value && (
                                <div className="info-row">
                                  <span className="info-label">{obj.label}:</span>
                                  <span className="info-value">{obj.value}</span>
                                </div>
                              )
                            ))}
                          </div>
                        </div>
                        <div className="student-wallet-footer">
                          <span>COLLEGE BARCODE</span>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="h-100" style={{ position: "relative" }}>
                        <div className="container">
                          <div className={`flip-card ${isFlipped ? "flipped" : ""}`} onClick={handleFlip}>
                            <div className="flip-card-inner">
                              <div className="flip-card-front flex-center">
                                <div className="apple-wallet-outline">
                                  <div className="apple-side-left">
                                    <div className="apple-company-title">NEOIN</div>
                                    <div className="apple-social-icons">
                                      <img
                                        src={dribbleapp}
                                        alt="apple-1"
                                        className="my-1"
                                        style={{ width: "24px", height: "24px" }}
                                      />
                                      <img src={Whatsapp} alt="apple-2" className="my-1" />
                                      <img
                                        src={linkin}
                                        alt="apple-3"
                                        className="my-1"
                                        style={{ width: "24px", height: "24px" }}
                                      />
                                      <img
                                        src={gitthub}
                                        alt="apple-4"
                                        className="my-1"
                                        style={{ width: "24px", height: "24px" }}
                                      />
                                      <img
                                        src={msginput}
                                        alt="apple-5"
                                        className="my-1"
                                        style={{ width: "24px", height: "24px" }}
                                      />
                                    </div>
                                    <div className="apple-border">
                                      <img src={applewalletbottom} alt="borderbottom" />
                                    </div>
                                  </div>
                                  <div className="apple-main-content">
                                    <div className="apple-profile">
                                      <img
                                        src={ProfilePicture}
                                        alt="profile-photo"
                                        className="profilepicture"
                                      />
                                    </div>
                                    <div className="apple-title" style={{ marginTop: "10px" }}>
                                      {userDetails.name}
                                    </div>
                                    <div className="apple-title">{cardDetails.Company}</div>
                                    <div className="apple-title">{Designation}</div>
                                    <div className="apple-border-right">
                                      <div className="apple-border-title">09/24</div>
                                      <img src={mastercard} alt="mastercard" className="" />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="flip-card-back flex-center qr-flipcard-back">
                                <div className="qr-main-container">
                                  <div className="qr-card-content">
                                    <div className="qr-card-title">
                                      Scan to Connect
                                    </div>
                                    <QrCodeCard CARDNAME_id={id} />
                                    <div className="qr-card-subtitle">
                                      Point your camera at the QR code
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </motion.div>

      <motion.div className="card-box-1 my-4 me-4" ref={Column3Ref} style={{ maxHeight: `${availableHeight3}px`, overflowY: "auto", scrollbarWidth: "none", }} initial="hidden"
        animate="visible"
        exit="exit"
        variants={rightToLeftVariants}
        transition={{ duration: 0.5 }}>
        <div className="professional-social-title other-cards-title pt-3 px-3">Other Cards</div>
        <div className="" >
          <div className="scrollable-container-cont">

            {AllCards
              .filter(card => card.card_name !== id)
              .map(card => {
                // Find the matching card details and styles for each card
                const CardDetailsFilterByName = cardDetailsAll?.find((state) => state?.CardName === card.card_name);
                const CardDeailsForStyles = cardStylesAll?.find((state) => state?.CardName === card.card_name);

                // If no card details are found, return null
                if (!CardDetailsFilterByName) return null;

                // Now, CardDetailsFilterByName and CardDeailsForStyles will each hold only one object or undefined if no match is found
                // console.log("Style", CardDetailsFilterByName);

                // Set default values if data or styles are missing
                const styles = CardDeailsForStyles || {}; // Use an empty object if no styles are found
                const companyLogoData = CardDetailsFilterByName?.logo || DefaultLogo;
                const profilePic = CardDetailsFilterByName?.profile_pic || DefaultProfileBg;
                const cardBackgroundColor = styles?.bgColor || "#ffffff";
                const colorLayout = styles?.colorLayout || '#0044c6';
                const colorPrimary = styles?.colorPrimary;
                const colorSecondary = styles?.colorSecondary;
                const fontFamily = styles?.font;
                const cardType = card.card_type;

                return (
                  <div key={card.card_name} className={`digi-card card-row card-professional`} style={{ backgroundColor: cardBackgroundColor, marginLeft: "unset", fontFamily: fontFamily }}>
                    <a href={`/card/${card.card_name}`}>
                      <div className='digi-card-upper' style={{
                        backgroundImage: `url(${profilePic})`,
                        position: "relative"
                      }}>
                        <div className='digi-card-label-container' style={{ backgroundColor: colorLayout }}>
                          <span className='digi-card-label'>{card.card_name}</span>
                        </div>

                        {(cardType === 'Personal' || cardType === 'Customize_Personal') ? (
                          <CardWaveSmile bgColor={cardBackgroundColor} strokeColor={colorLayout} small />
                        ) : (
                          <CardWaveStd bgColor={cardBackgroundColor} strokeColor={colorLayout} small />
                        )}

                        {(cardType === 'Personal' || cardType === 'Customize_Personal') ? null : (
                          <div className='company-logo-container flex-center'>
                            <img src={companyLogoData} alt="Company" className='prof-company-logo' />
                          </div>
                        )}
                      </div>
                      <div className='digi-card-lower'>
                        <h2 className='digi-card-Name' style={{ color: colorPrimary }}>{firstName}</h2>
                        <span className='Profession' style={{ color: colorSecondary }}>
                          {(cardType === "Professional" || cardType === "Customize_Professional")
                            ? (CardDetailsFilterByName?.companyName ? `${CardDetailsFilterByName?.companyName} - ${CardDetailsFilterByName?.designation}` : CardDetailsFilterByName?.designation)
                            : CardDetailsFilterByName?.title}
                        </span>
                      </div>
                    </a>
                  </div>
                );
              })
            }

          </div>
        </div>
      </motion.div>


      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={
          <div>
            <strong>{snackbarMessage.title}</strong>
            <div>{snackbarMessage.body}</div>
          </div>
        }
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        anchorOrigin={{
          vertical: 'top',    // Position at the top
          horizontal: 'right', // Position at the right
        }}

      />
    </div >

  );
}

export default CardDetailedView;